import * as React from 'react';
import b_ from 'b_';
import { Link } from 'shared/components/Link';
import { useTranslation } from 'react-i18next';
import { OrderIdeaFragment } from './__generated__/OrderIdeaFragment';
import { OrderStockFragment } from './__generated__/OrderStockFragment';
import StockIcon from 'components/StockIcon';
import { ProductType } from '../../types';

import './index.scss';

type Product = OrderIdeaFragment | OrderStockFragment;

interface Props {
  product: Product;
  className?: string;
}

const b = b_.with('order-card-product');

function getUrl(product: Product) {
  switch (product.__typename) {
    case ProductType.Idea:
      return `/idea/${product.ideaType.toLowerCase()}/${product.id}`;
    case ProductType.Stock:
      return `/stocks/${product.id}`;
  }
}

function getCategory(product: Product) {
  switch (product.__typename) {
    case ProductType.Idea:
      return product.category;
    case ProductType.Stock:
      return product.type;
  }
}

function getName(product: Product) {
  switch (product.__typename) {
    case 'Investment_Idea':
      return product.name;
    case ProductType.Stock:
      return product.title || '';
  }
}

export const Product: React.FC<Props> = ({ product, className }) => {
  const { t } = useTranslation();
  return (
    <Link className={className} to={`/investments${getUrl(product)}`}>
      <div className={b('logo-wrapper')}>
        <StockIcon url={product.logoUrl} name={product.name} mid />
      </div>
      <div className={b('name-wrapper')}>
        <span className={b('name')} title={getName(product)} data-testid="product-name">
          {getName(product)}
        </span>
        <span className={b('category')} data-testid="product-description">
          {t(getCategory(product))}
        </span>
      </div>
    </Link>
  );
};
